import React, { useEffect, useState } from "react";
import CustomDatePickerMui from "../../models/inputs/DateInput";
import {
  dateFormated,
  presentFormatedData,
} from "../../functionalComponents/dataFormatFunctions";
import EditIcon from "@material-ui/icons/Edit";
import SaveIcon from "@material-ui/icons/Save";
import ClearIcon from "@material-ui/icons/Clear";
import {
  Box,
  Dialog,
  DialogContent,
  Grid,
  InputAdornment,
  MenuItem,
  TextField,
  Typography,
} from "@material-ui/core";
import WarningIcon from "@material-ui/icons/Warning";
import CloseIcon from "@material-ui/icons/Close";
import axios from "axios";
import { appUrl } from "../../../../../../utils/config";
import StyledDialog from "../../updateGrRecord/Dialog";
import StyledButton from "../../models/Button";
import ArrowDropDownIcon from "@material-ui/icons/ArrowDropDown";
import jwt_decode from "jwt-decode";
import { useDispatch } from "react-redux";
import {
  DESTROY_BACKDROP,
  OPEN_BACKDROP,
} from "../../../../containers/actions/types";

const EditAboRisk = (props) => {
  const { row, handleRefresh, featuresAccess,userAssociations, selectedCMOs,
  selectedBrands,showPencilIcon, col8to10Style}= props;
  const dispatch = useDispatch();
  const [edit, setEdit] = useState(false);
  const [saveFailed, setSaveFailed] = useState(false);
  const [savedSuccessfull, setSavedSuccessfull] = useState(false);

  const { roleName, organizationName, authToken } = localStorage;
  var token = authToken;
  var decoded = jwt_decode(token);
  //console.log("SelectedCMOs in EditPO:", selectedCMOs);
  //console.log("selectedBrands in EditPO:", selectedBrands);

 

const canEdit = () => {
  const userCMOAssociations = userAssociations?.data?.associatedCMOList || [];
  const userBrandAssociations = userAssociations?.data?.associatedBrandList || [];

  //console.log("Selected CMOs:", selectedCMOs);
  //console.log("Selected Brands:", selectedBrands);
  //console.log("User CMO Associations:", userCMOAssociations);
  //console.log("User Brand Associations:", userBrandAssociations);

  // Ensure arrays are valid
  const isSelectedCMOsValid = Array.isArray(selectedCMOs);
  const isSelectedBrandsValid = Array.isArray(selectedBrands) && selectedBrands.length > 0;

  // Check CMO intersection if selectedCMOs is non-empty
  const cmoIntersection = isSelectedCMOsValid && selectedCMOs.length > 0
    ? selectedCMOs.map(String).filter((cmo) =>
        userCMOAssociations.map(String).includes(cmo)
      )
    : [];

  // Check brand intersection
  const brandIntersection = isSelectedBrandsValid
    ? selectedBrands.map(String).filter((brand) =>
        userBrandAssociations.map(String).includes(brand)
      )
    : [];

  //console.log("Matching CMOs:", cmoIntersection);
  //console.log("Matching Brands:", brandIntersection);

  // Allow edit if there is at least one matching brand or CMO
  return brandIntersection.length > 0 || cmoIntersection.length > 0;
};

  const [textValue, setTextValue] = useState(
       row?.scheduleLineDetails?.aboRisk
      ? presentFormatedData(row?.scheduleLineDetails?.aboRisk)
      : "none"
  );

  useEffect(() => {
    setTextValue(
      row?.scheduleLineDetails?.aboRisk
        ? presentFormatedData(row?.scheduleLineDetails?.aboRisk)
        : "none"
    );
  }, [row?.scheduleLineDetails?.aboRisk]);

    const aboRiskDisplayValue =
    !row?.scheduleLineDetails?.aboRisk ||
    row?.scheduleLineDetails?.aboRisk === "none"
      ? "Select from list"
      : row?.scheduleLineDetails?.aboRisk;

  const handleCloseSave = () => {
    setSaveFailed(false);
    handleRefresh();
  };

  const handleSave = () => {
    setEdit(false);
    dispatch({ type: OPEN_BACKDROP });
    const requestObj = {
      schrockenSLID: row?.scheduleLineDetails?.schrockenSLID ?? null,
      aboRisk: textValue,
      vendorMosymphonyID: row?.scheduleLineDetails?.vendorMosymphonyID ?? null,
    };

    axios
      .post(
        `${appUrl}/${localStorage.appName}/${localStorage.network}/${localStorage.collabType}/${localStorage.roleName}/updateSLForPOMgmt`,
        requestObj
      )
      .then((res) => {
        dispatch({ type: DESTROY_BACKDROP });
        if (res.data.status && res.data.data) {
          setSavedSuccessfull(true);
        } else {
          setSaveFailed(true);
        }
      })
      .catch((err) => {
        dispatch({ type: DESTROY_BACKDROP });
        setSaveFailed(true);
        // console.log("Error fetching documents:", err);
      });
  };

  return (
    <div>
      {localStorage.collabType !== "CMO" ? (
        // && row?.scheduleLineDetails?.plannerEmailID === decoded.email_address
        edit ? (
          <Box style={{ display: "flex", alignItems: "center", gap: "10px" }} >
            <TextField
              select
              value={textValue}
              onChange={(e) => setTextValue(e.target.value)}
              variant="outlined"
              size="small"
              style={{ width: "125px" }}
              className={col8to10Style}
            >
              <MenuItem value="none">Select from list</MenuItem>
              <MenuItem value="Low">Low</MenuItem>
              <MenuItem value="Medium">Medium</MenuItem>
              <MenuItem value="High">High</MenuItem>
            </TextField>
            <Box
              style={{ display: "flex", flexDirection: "column", gap: "3px" }}
            >
              <span title="save">
                <SaveIcon
                  onClick={handleSave}
                  style={{ cursor: "pointer", fontSize: "small" }}
                 
                />
              </span>
              <span title="clear">
                <ClearIcon
                  onClick={() => setEdit(false)}
                  style={{ cursor: "pointer", fontSize: "small" }}
                  
                />
              </span>
            </Box>
          </Box>
        ) : (
          <Box style={{ display: "flex", alignItems: "center", gap: "10px" }}>
            {/* {presentFormatedData(row?.SLDetails?.aboRisk || 'NA')} */}
            {/* <span>{row?.scheduleLineDetails?.aboRisk || "NA"}</span> */}
            <TextField
              value={aboRiskDisplayValue}
              variant="outlined"
              size="small"
              disabled
              style={{ width: "125px" }}
              className={col8to10Style}
              InputProps={{
                style: aboRiskDisplayValue === "Select from list" ? { color: "#999" } : {},
                endAdornment: (
                  <InputAdornment position="end">
                    <ArrowDropDownIcon />
                  </InputAdornment>
                ),
              }}
            />

            {row?.scheduleLineDetails?.scheduleLineStatusID !== 30 &&
            showPencilIcon && featuresAccess?.editAboRisk === true && (
                <Box
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    gap: "3px",
                  }}
                >
                  <span title="Edit">
                    <EditIcon
                      fontSize="large"
                      onClick={() => setEdit(true)}
                      style={{ cursor: "pointer", color: "#ec6535" }}
                    />
                  </span>
                </Box>
              )}
          </Box>
        )
      ) : (
        // <span>{row?.scheduleLineDetails?.aboRisk || "NA"}</span>
        <TextField
          value={aboRiskDisplayValue}
          variant="outlined"
          size="small"
          disabled
          style={{ width: "125px" }}
          InputProps={{
            style: aboRiskDisplayValue === "Select from list" ? { color: "#999" } : {},
            endAdornment: (
              <InputAdornment position="end">
                <ArrowDropDownIcon />
              </InputAdornment>
            ),
          }}
        />
      )}

      <Dialog open={savedSuccessfull} fullWidth>
        <StyledDialog
          icons={true}
          handleClose={handleCloseSave}
          title={"Saved successfully"}
        />
      </Dialog>
      <Dialog
        open={saveFailed}
        onClose={() => {
          setSaveFailed(false);
        }}
        fullWidth
      >
        <DialogContent style={{ padding: "2rem" }}>
          <Grid container justifyContent="flex-end">
            <Typography
              variant="body2"
              style={{
                fontSize: "1rem",
                fontWeight: 500,
                display: "flex",
                alignItems: "center",
                cursor: "pointer",
              }}
              onClick={() => {
                setSaveFailed(false);
              }}
            >
              Close <CloseIcon fontSize="large" />
            </Typography>
            <Grid
              item
              xs={12}
              style={{ display: "flex", justifyContent: "center" }}
            >
              <WarningIcon
                style={{
                  fontSize: "5rem",
                  color: "#F00",
                }}
              />
            </Grid>
          </Grid>
          <div
            style={{
              display: "flex",
              justifyContent: "center", // Horizontally center the CircularProgress
              alignItems: "center", // Vertically center the CircularProgress
              height: "80px", // Optional: Set a height to vertically center the loader
              border: "2px solid #FF0000",
              backgroundColor: "#FFF0F0",
              // width: "100%",
            }}
          >
            <Typography style={{ textAlign: "center" }}>
              Something went wrong. Please try again.
            </Typography>
          </div>
          <Grid
            item
            xs={12}
            style={{
              display: "flex",
              justifyContent: "center",
              textAlign: "center",
              padding: "0.5rem",
            }}
          >
            <StyledButton
              style={{ paddingLeft: "3rem", paddingRight: "3rem" }}
              onClick={() => {
                setSaveFailed(false);
              }}
            >
              Ok
            </StyledButton>
          </Grid>
        </DialogContent>
      </Dialog>
    </div>
  );
};

export default EditAboRisk;
